<script>
import PopUp from "./PopUp.vue";
import axios from "axios";
export default {
  components: { PopUp },
  data: function () {
    return {
      error: false,
      error_msg: ""
    };
  },
  props: {
    exportar: Boolean,
    data: [],
    file: String,
    request:null,
  },
  methods: {
    convertDataObjectUrl(data) {
      return Object.keys(data)
        .map(function (k) {
          return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
          
        })
        .join("&");
    },
    mostrarEstado(reserva){
      if(reserva.estado=="PENDIENTE")
        return "PENDIENTE DE CONFIRMACIÓN";

      return reserva.estado;
    },
    mostrarNombre(reserva) {
      if(reserva.usuario){
        return reserva.usuario.nombre;
      }
      return reserva.usuarioNoRegistrado.nombre ;
    },
    mostrarTelefono(reserva){
      if(reserva.usuario){
        return reserva.usuario.telefono;
      }
      return reserva.usuarioNoRegistrado.telefono ;
    },
    mostrarEmail(reserva) {
      if(reserva.usuario){
        return reserva.usuario.email;
      }
      return reserva.usuarioNoRegistrado.email ;
    },
    exportarAExcel(fileName) {
      if (confirm("Desea exportar la tabla actual a excel?")) {
        this.request.page=0;
        this.request.size=-1;
        axios.get("/getReservas?"+ this.convertDataObjectUrl(this.request)).then((data) => {
        if (data.status == 200) {
          let dataExport=[];
          data.data.items.forEach((reserva) => {
            Object.keys(reserva).forEach(
              (k) => !reserva[k] && reserva[k] !== undefined && delete reserva[k]
            );

            if(reserva.estado=="PENDIENTE"){
              reserva.estado="PENDIENTE DE CONFIRMACIÓN";
            }

            dataExport.push(
            {
              'Codigo':reserva.id,
              "Fecha de Registro":reserva.fechaRegistro,
              "Fecha de Reserva":reserva.fecha,
              "Horario":reserva.horario + ':'+ reserva.minutos+" hs.",
              "Cantidad Mayores":reserva.comensales_mayores,
              "Cantidad Menores":reserva.comensales_menores,
              "Nombre":this.mostrarNombre(reserva),
              "Telefono":this.mostrarTelefono(reserva),
              "Email":this.mostrarEmail(reserva),
              "Estado":this.mostrarEstado(reserva),
            
              
            }


            );

          });
          var XLSX = require("xlsx");
          let dataC = XLSX.utils.json_to_sheet(dataExport);
          const workbook = XLSX.utils.book_new();
          const filename = fileName;
          XLSX.utils.book_append_sheet(workbook, dataC, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);


        } else {
          this.error = true;
          this.error_msg =
            "No se ha podido buscar las reservas. Vuelva a intentar mas tarde";
        }
      });


          
      }
    },
  },
};
</script>

<template>
  <html>
    <body>
      <button
        v-show="exportar"
        type="button"
        class="btn btn-primary mb-3"
        style="margin: 0 !important"
        v-on:click="exportarAExcel(file)"
      >
        Exportar a Excel
      </button>

      <PopUp :show="error" @close="error = false">
        <template #body>
          <p>{{ error_msg }}</p>
        </template>
      </PopUp>
    </body>
  </html>
</template>

<style>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

:host {
  --main-color: #0047b3;
  --second-color: #0198f3;
  --grey-color: #f5f8fa;
  --border-radius-1: 9px;
  --border-radius-2: 6px;
}

body {
  font-family: "Inter", sans-serif;
  color: #083744;
  font-size: 14px;
  height: 100%;
}
</style>
